// extracted by mini-css-extract-plugin
module.exports = {"go":"YCOY5od0","button":"ZBS_WFbj","subtitle":"Yt2008Mh"};